import { render, staticRenderFns } from "./TakenIpulseCommentSection.vue?vue&type=template&id=6e8e7e1e&"
import script from "./TakenIpulseCommentSection.vue?vue&type=script&lang=ts&"
export * from "./TakenIpulseCommentSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports